@import "./bootstrap_variables.scss";
@import url("https://fonts.googleapis.com/css?family=Montserrat:500,700,900|Open+Sans:300,400,600,700,800|DM+Serif+Display&display=swap");

@import "bootstrap/scss/bootstrap";

@import "./variables.scss";
@import "./globals.scss";
